import { match } from 'path-to-regexp';

export const getMatchPath = ({ path = '', pattern }) =>
  match(pattern || '', {
    sensitive: true,
  })(path);

export const getCurrentPageType = ({ params }) => {
  const { companySlug, skuSlug, productId, landing } = params;

  if (landing) {
    return 'landingPage';
  }

  if (companySlug && !skuSlug) {
    return 'companyPage';
  }

  if (companySlug && skuSlug && productId) {
    return 'productPage';
  }

  return 'homePage';
};
